<template>
  <div>
    <el-form
      label-position="top"
      size="small"
    >
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="Date To">
            <el-date-picker
              v-model="form.dateTo"
              type="date"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              placeholder="Pick a day"
              :picker-options="pickerOptions"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item label="Customer">
            <AccountAutoComplete
              ref="accountAutoComplete"
              v-model="account"
              @loadCarrier="loadCarrier"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Carrier">
            <CarrierAutoComplete
              ref="carrierList"
              v-model="carrier"
              placeholder="All Carrier"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="8">
          <el-form-item>
            <el-checkbox
              v-model="form.showAccepted"
              label="Show Accepted"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-checkbox
              v-model="form.showIgnored"
              label="Show Ignored"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <el-checkbox
              v-model="form.showHeld"
              label="Show Held"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          size="small"
          class="float-right"
          @click.native="downloadCSV()"
        >
          Generate Report
        </el-button>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="isShowPreview"
      title="Uninvoiced Reconciled"
      width="70vw"
      top="5vh"
      :close-on-click-modal="false"
      @closed="isShowPreview = false"
    >
      <h2>Due to the size of this report it will be emailed to you</h2>
      <p>The status can be checked from the jobs menu in the top right corner</p>
    </el-dialog>
  </div>
</template>

<script>

import CarrierAutoComplete from '@/components/Application/Reports/CarrierAutoComplete'
import AccountAutoComplete from '@/components/Application/Reports/AccountAutoComplete'
import Request from '@/plugins/sdk/Request'

export default {
  components: {
    CarrierAutoComplete,
    AccountAutoComplete
  },
  data () {
    return {
      breadcrumb: {
        name: 'Uninvoiced Reconciled',
        route: { name: 'reports-invoice-uninvoiced' }
      },
      account: {},
      carrier: {},
      form: {
        carrierId: null,
        dateTo: new Date(),
        showAccepted: true,
        showIgnored: false,
        showHeld: false

      },
      isShowPreview: false,
      configuration: null,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: 'Today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'A week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },
  methods: {
    loadCarrier () {
      this.form.accountId = this.$refs.accountAutoComplete.getAccountIds()
    },
    async fetchData (configuration) {
      const response = await fetch(await Object.assign(new Request(), {
        _pathname: `/reports/${configuration.report}`,
        filters: configuration.params
      }).build())

      if (response.ok) {
        this.isLoading = false
        this.isShowPreview = true
      } else {
        this.isLoading = false
        this.$message({
          showClose: true,
          message: 'Unable to process report request',
          type: 'error'
        })
      }
    },
    async downloadCSV () {
      this.isLoading = true
      this.form.dateTo = this.$moment(this.form.dateTo).format('YYYY-MM-DD HH:mm:ss')
      if (this.$refs.carrierList.getCarrierId()) {
        this.form.carrierId = this.$refs.carrierList.getCarrierId()
      }

      this.configuration = {
        report: 'UnInvoicedReconciled',
        params: this.form
      }
      await this.fetchData({
        report: 'UnInvoicedReconciled',
        params: this.form
      })
    }
  }
}
</script>
